import { useTranslation } from "react-i18next"
import { Button, Form } from 'react-bootstrap'
import { useState } from "react"
import { useDispatch } from "react-redux"
import { addRegisterCounter } from "../../../actions/countersActions"
import jwtDecode from "jwt-decode"
import Swal from "sweetalert2"

export default function FormCounter({counter}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    let token = jwtDecode(sessionStorage.getItem('jwt'))
    
    const [quantity, setQuantity] = useState(0)
    const [type, setType] = useState('kW h')

    const addRegister = () => {
        dispatch(addRegisterCounter(quantity, token?.id, type, counter))
        setQuantity(0)
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('counters.setregistersuccessful')
        })
    }

    const setQuantityValue = (target) => {
        setQuantity(target.target.value)
    }

    const setTypeValue = (target) => {
        setType(target.target.value)
    }

    return (
        <>
            <Form.Label>{t('counters.setregisternew')}</Form.Label>
            <Form.Group className="w-50">
                <Form.Control 
                    onChange={setQuantityValue}
                    id="setregister"
                    className="form-control"
                    type='number'
                    name='register'
                    value={quantity}
                    placeholder={t('counters.register')}
                />
            </Form.Group>
            <Form.Group className="w-50">
                <Form.Control
                    onChange={setTypeValue}
                    as="select"
                    id='type'
                    name='type'
                    placeholder={t('counters.type')}
                >
                    <option value='kWh' defaultValue>{t('counters.kWh')}</option>
                    <option value='L'>{t('counters.l')}</option>
                    <option value='M³'>{t('counters.m3')}</option>
                </Form.Control>
            </Form.Group>
            <div className="custom-card-buttom row">
                <Button className="btn btn-secondary my-2 mx-auto" type="submit" onClick={addRegister}><i className="fas fa-save"></i> {t('counters.registernew')}</Button>
            </div>
        </>
    )    
}
